<template>
	<transition 
			appear
			:appear-active-class="$_dtTblLyt_stylePageLayoutAnimation()">
		<v-row	class="customVRow" 
				align="start"
				no-gutters>
			<v-col>
				<v-data-table
						class="table_"

						:dark="$_dtTblLyt_styleDataTableDark"
						:dense="$_dtTblLyt_styleDataTableDense"
						:light="$_dtTblLyt_styleDataTableLight"

						:headers="$_dtTblLyt_infoHeaders"
						:items="$_dtTblLyt_getItems()">
					<template v-slot:[`item.action`]="{ item }">
						<v-row dense>
							<template v-for="(actionButtonVals, actionButtonKey) in sortObject(item.actionButtons, 'order')">
								<v-col :key="actionButtonKey">
									<v-btn	class="customVBtn"
											x-small
											:block="$_dtTblLyt_styleActionButtonBlock"
											:color="$_dtTblLyt_styleActionButtonColor"
											:dark="$_dtTblLyt_styleActionButtonDark"
											:depressed="$_dtTblLyt_styleActionButtonDepressed"
											:elevation="$_dtTblLyt_styleActionButtonElevation"
											:light="$_dtTblLyt_styleActionButtonLight"
											:outlined="$_dtTblLyt_styleActionButtonOutlined"
											:rounded="$_dtTblLyt_styleActionButtonRounded"
											:text="$_dtTblLyt_styleActionButtonFlat"
											@click="openLink(actionButtonVals.link)"
											v-text="$_dtTblLyt_langActionButtonTitle(actionButtonVals)" />
								</v-col>
							</template>
						</v-row>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'DataTableLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				search_: ''
			}
		},
		computed: {
			// state
			$_dtTblLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			// info
			$_dtTblLyt_infoHeaders() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.inits, 'headers')
			},
			// (content - action button)
			$_dtTblLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// style
			$_dtTblLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_dtTblLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_dtTblLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_dtTblLyt_styleDataTable() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'dataTable')
			},
			$_dtTblLyt_styleDataTableDark() {
				const self_ = this;
				const banner_ = self_.$_dtTblLyt_styleDataTable;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.dark)
			},
			$_dtTblLyt_styleDataTableDense() {
				const self_ = this;
				const banner_ = self_.$_dtTblLyt_styleDataTable;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.dense)
			},
			$_dtTblLyt_styleDataTableLight() {
				const self_ = this;
				const banner_ = self_.$_dtTblLyt_styleDataTable;
				if(self_.isFalse(banner_)) { return null }
				return self_.getStylesVal(banner_.light)
			},
			$_dtTblLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_dtTblLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_dtTblLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_dtTblLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_dtTblLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_dtTblLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_dtTblLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_dtTblLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_dtTblLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_dtTblLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_dtTblLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_dtTblLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_dtTblLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_dtTblLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_dtTblLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_dtTblLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_dtTblLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_dtTblLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_dtTblLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_dtTblLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_dtTblLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_dtTblLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_dtTblLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			}
		},
		methods: {
			$_dtTblLyt_getItems() {
				const self_ = this;

				let items_ = []

				Object.keys(self_.contents).forEach(key => {
					let item_ = self_.contents[key]
					item_.key = key;
					items_.push(self_.contents[key])
				})

				return items_
			}
		}
	}
</script>

<style scoped>
	.table_ {
		background-color: transparent;
	}
</style>
